import FormImageManager from './FormImageManager';

export default FormImageManager;
